import * as z from "zod/v4";

export const getVariables = {
  name: "getVariables" as const,
  input: z.object({}),
  output: z.object({
    variables: z.array(
      z.object({
        id: z.string(),
        label: z.string(),
        dynamic: z.boolean(),
        inputSchema: z.record(z.string(), z.unknown()),
      }),
    ),
  }),
};
